const settings = {
    // baseDamCardamageUrl: "https://localhost:5001/aftenbil-cardamage", // and add for example:  /QSIS88UchX/rickard_robin.JPG 
    baseDamCardamageUrl: "https://grok.aftenbil.se/buckets/aftenbil-cardamage", // and add for example:  /QSIS88UchX/rickard_robin.JPG 
    baseDamCardamageUploadFolder: "temp-uploads", 
    baseDamCardamageMoveImagesUrlPart: "move-temp-uploads", 
    baseGoogleStorageCardamageUrl: "https://storage.googleapis.com",
    apiKey: "10d2ee40-c5aa-49dd-9b5a-75a19885e906"
}

export default settings;